import { Control, FieldValues, UseFormSetValue } from "react-hook-form";

import { IFormAttributes, TrafficTypeEnum, TTimeHHmm } from "@ryde/shared";

export interface IAvailabilityItem {
  from: TTimeHHmm | null;
  to: TTimeHHmm | null;
  dayTypeIds: number[] | null;
  dayGroupIds: number[] | null;
  traffic: TrafficTypeEnum;
}

export interface IAvailabilityItemForm {
  fieldName: string;
  control?: Control;
  index?: number;
  onEdit?: () => void;
  onCancelOuter?: () => void;
  onEditStart?: () => void;
  onEditEnd?: () => void;
  value?: Partial<IAvailabilityItem>;
  setValueOuter?: UseFormSetValue<FieldValues>;
  removeHandler?: (index: number) => void;
  formAttributes?: IFormAttributes | null;
  disabledEdit?: boolean;
  disabledRemove?: boolean;
}

export const emptyAvailability: IAvailabilityItem = {
  from: null,
  to: null,
  dayTypeIds: null,
  dayGroupIds: null,
  traffic: TrafficTypeEnum.Normal,
};

export const availabilityFormFieldNames: (keyof IAvailabilityItem)[] = [
  "from",
  "to",
  "dayTypeIds",
  "dayGroupIds",
  "traffic",
];

export const availabilitySerialized = (item: IAvailabilityItem): string => {
  return `${item?.dayGroupIds?.join(",") || ""}-${item?.dayTypeIds?.join(",")} `;
};
